




import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { EntityFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { UserFilterParameter } from ".";
import ProjectTeamDropDownSelector from "../../projectTeam/selectors/ProjectTeamDropDownSelector.vue";
import { ProjectTeam } from "../../../domain/projectTeam";

@Component({
  components: {
    StringFilter,
    ProjectTeamDropDownSelector,
  },
})
export default class ProjectTeamMemberFilter extends Mixins(ModelEditableMixin) {
  editingSource: UserFilterParameter;

  @Prop()
  projectTeam: ProjectTeam;

  get projectTeamSource(): ProjectTeam {
    return this.projectTeam;
  }

  set projectTeamSource(source: ProjectTeam) {
    this.$emit("update:projectTeam", source);
  }

  @Watch("projectTeam", { immediate: true })
  onProjectTeamChanged(newValue: ProjectTeam, oldValue: ProjectTeam) {
    this.updateProjectTeamUsers();
  }

  updateProjectTeamUsers(): void {
    const users = this.projectTeam
      ? this.projectTeam.members.map(m => m.user)
      : null;
    this.projectTeamUsers = new EntityFilterParameter(users);
  }

  get projectTeamUsers(): EntityFilterParameter {
    return this.editingSource.projectTeamUsers;
  }

  set projectTeamUsers(source: EntityFilterParameter) {
    this.writeProperty(s => s.projectTeamUsers = source);
  }
}
